import type { INotifyParams } from "../utils/notification";

import { notify } from "../utils/notification";

export const notificationService = {
  success: (params: INotifyParams) => notify("success", params),
  danger: (params: INotifyParams) => notify("danger", params),
  warning: (params: INotifyParams) => notify("warning", params),
  info: (params: INotifyParams) => notify("info", params),
};
